import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import './portal.css';
import { DATA_URL, PASSCODE, CAMPANA } from './config';
import { mapearEncabezados, filaARegistro, leerCSV } from './mapeo';
import Marco from './Marco';
import Tablero from './Tablero';
import Pacientes from './Pacientes';

// array-of-arrays (headers + rows) → registro objects the dashboard understands
function filasARegistros(filas) {
  if (!filas || filas.length < 2) return [];
  const mapa = mapearEncabezados(filas[0]);
  if (mapa.documento === undefined) return [];
  const out = []; const vistos = new Set();
  for (let i = 1; i < filas.length; i++) {
    const r = filaARegistro(filas[i], mapa, 'file');
    if (!r || vistos.has(r.documento)) continue;
    vistos.add(r.documento); out.push(r);
  }
  return out;
}

async function parsearBuffer(buf, nombre) {
  if (/\.csv$/i.test(nombre)) return leerCSV(new TextDecoder('utf-8').decode(buf));
  const libro = XLSX.read(buf, { type: 'array', cellDates: true });
  const hoja = libro.Sheets[libro.SheetNames[0]];
  return XLSX.utils.sheet_to_json(hoja, { header: 1, raw: true, defval: null });
}

export default function DynamicBpoPortal() {
  const [ok, setOk] = useState(!PASSCODE);
  const [clave, setClave] = useState('');
  const [vista, setVista] = useState('panel');
  const [registros, setRegistros] = useState(null); // null = cargando
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!ok) return undefined;
    if (!DATA_URL) { setRegistros([]); return undefined; }
    let cancel = false;
    (async () => {
      try {
        const r = await fetch(DATA_URL, { cache: 'no-store' });
        if (!r.ok) throw new Error('nofile');
        const filas = await parsearBuffer(await r.arrayBuffer(), DATA_URL);
        if (!cancel) setRegistros(filasARegistros(filas));
      } catch {
        if (!cancel) setRegistros([]);
      }
    })();
    return () => { cancel = true; };
  }, [ok]);

  async function cargarLocal(file) {
    if (!file) return;
    setErr('');
    try {
      const filas = await parsearBuffer(await file.arrayBuffer(), file.name);
      const regs = filasARegistros(filas);
      if (!regs.length) throw new Error('No se reconocieron registros. ¿El archivo trae una columna DOCUMENTO?');
      setRegistros(regs); setVista('panel');
    } catch (e) { setErr(e.message); }
  }

  if (!ok) {
    return (
      <div className="dbpo"><div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20 }}>
        <form className="card" style={{ width: 'min(380px,92vw)' }} onSubmit={(e) => { e.preventDefault(); setOk(clave === PASSCODE); }}>
          <div className="brand" style={{ justifyContent: 'center', padding: '2px 0 16px' }}>
            <div className="logo">D</div>
            <div><div className="bt">DYNAMIC BPO</div><div className="bs">TU EQUIPO · TU MISIÓN</div></div>
          </div>
          <div className="campo"><label>Código de acceso</label>
            <input type="password" value={clave} onChange={(e) => setClave(e.target.value)} autoFocus /></div>
          <button className="primario" style={{ width: '100%' }}>Entrar</button>
        </form>
      </div></div>
    );
  }

  const perfil = { nombre: 'Dynamic BPO', rol: 'admin' };
  const campana = { ...CAMPANA, organizaciones: { nombre: CAMPANA.organizacion } };

  return (
    <div className="dbpo">
      <Marco perfil={perfil} activo={vista} onNav={setVista} onSalir={() => { if (PASSCODE) setOk(false); }}>
        {vista === 'panel' && (
          registros === null
            ? <div className="card"><p className="mut">Cargando datos…</p></div>
            : (registros.length
                ? <Tablero registros={registros} campana={campana} />
                : (
                  <div className="card">
                    <h2>Sin datos todavía</h2>
                    <p className="mut" style={{ marginTop: 8 }}>
                      Agregue el archivo <b>{DATA_URL}</b> al repositorio (carpeta <b>public</b>), o use
                      <b> Cargar archivo</b> para ver una vista previa ahora mismo.
                    </p>
                  </div>
                ))
        )}

        {vista === 'pacientes' && <Pacientes registros={registros || []} />}

        {vista === 'cargar' && (
          <>
            <h1 style={{ marginBottom: 4 }}>Cargar archivo</h1>
            <p className="mut" style={{ marginBottom: 16 }}>
              Cargue un Excel (.xlsx) o CSV para ver una vista previa en este navegador. Para actualizar
              lo que ven todos, reemplace <b>{DATA_URL}</b> en el repositorio y vuelva a desplegar.
            </p>
            {err && <div className="aviso err">{err}</div>}
            <div className="card">
              <div className="campo"><label>Archivo (.xlsx o .csv)</label>
                <input type="file" accept=".xlsx,.xls,.csv" onChange={(e) => cargarLocal(e.target.files?.[0])} />
              </div>
              <p className="mut">La vista previa reemplaza los datos mostrados hasta que recargue la página. Las columnas se reconocen por su nombre; solo el DOCUMENTO es obligatorio.</p>
            </div>
          </>
        )}
      </Marco>
    </div>
  );
}
